/**
 * Return true if the accountId is either `gerdhelp` or `vgcc`
 * @param {string} accountId 
 */
export default function(accountId) {
    if (accountId == 'gerdhelp' || accountId == 'vgcc')
        return true
    else
        return false
}